import React, { PropsWithChildren } from 'react';

import { FullPageSpinner } from '@/components/ui/fullPageSpinner/FullPageSpinner.comp';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

// TODO: find better solution

export const UserContextVerifier: React.FC<PropsWithChildren> = ({ children }) => {
  const user = useUserContext();

  if (!user.dataReady) {
    return <FullPageSpinner />;
  }

  return <>{children}</>;
};
